import React, {Component} from 'react'
import {withNamespaces} from 'react-i18next'
import Grid from '@material-ui/core/Grid'
import ".././assets/score-history-detail.css"
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import Paper from '@material-ui/core/Paper'
import i18n from '../i18n'
import httpRequest from '../components/request-api'
import {
    isMobile
} from "react-device-detect"
import moment from 'moment'

function createData(hole, par, score) {
    return {hole, par, score};
}

class ScoreHistoryDetail extends Component {
    constructor(props) {
        super(props);
        this.changeLanguage(this.props.lng)
        this.state = {
            scoreHis: this.props.scoreHis,
            hole_01: this.props.scoreHis ? this.props.scoreHis.hole_01 : "",
            hole_02: this.props.scoreHis ? this.props.scoreHis.hole_02 : "",
            hole_03: this.props.scoreHis ? this.props.scoreHis.hole_03 : "",
            hole_04: this.props.scoreHis ? this.props.scoreHis.hole_04 : "",
            hole_05: this.props.scoreHis ? this.props.scoreHis.hole_05 : "",
            hole_06: this.props.scoreHis ? this.props.scoreHis.hole_06 : "",
            hole_07: this.props.scoreHis ? this.props.scoreHis.hole_07 : "",
            hole_08: this.props.scoreHis ? this.props.scoreHis.hole_08 : "",
            hole_09: this.props.scoreHis ? this.props.scoreHis.hole_09 : "",
            hole_10: this.props.scoreHis ? this.props.scoreHis.hole_10 : "",
            hole_11: this.props.scoreHis ? this.props.scoreHis.hole_11 : "",
            hole_12: this.props.scoreHis ? this.props.scoreHis.hole_12 : "",
            hole_13: this.props.scoreHis ? this.props.scoreHis.hole_13 : "",
            hole_14: this.props.scoreHis ? this.props.scoreHis.hole_14 : "",
            hole_15: this.props.scoreHis ? this.props.scoreHis.hole_15 : "",
            hole_16: this.props.scoreHis ? this.props.scoreHis.hole_16 : "",
            hole_17: this.props.scoreHis ? this.props.scoreHis.hole_17 : "",
            hole_18: this.props.scoreHis ? this.props.scoreHis.hole_18 : "",
            course_code: this.props.scoreHis ? this.setName(this.props.scoreHis.course_id) : "",
            course_rating: this.props.scoreHis ? this.props.scoreHis.course_rating : "",
            slope_rating: this.props.scoreHis ? this.props.scoreHis.slope_rating : "",
            handicap_diff: this.props.scoreHis ? this.props.scoreHis.handicap_diff : "",
            score_total: this.props.scoreHis ? this.props.scoreHis.gross : "",
            teeoff: this.props.scoreHis ? this.props.scoreHis.teeoff : "",
            playDate: this.props.scoreHis ? moment(this.props.scoreHis.play_date).format('DD/MM/YYYY') : ""
        }

        if (this.props.match) {
            if (this.props.match.path === "/scoreHistory/:memberID/:id/:lang") {
                this.getScore(this.props.match.params.memberID, this.props.match.params.id)
            }
        }
    }

    setName = (item) => {
        if (this.props.lng === "th") {
            return `${item.name_th !== "-" ? item.name_th : item.name_en}`
        } else if (this.props.lng === "en") {
            return `${item.name_en !== "-" ? item.name_en : item.name_th}`
        } else {
            if (item.name_th !== '-') {
                return item.name_th
            } else if (item.name_en !== '-') {
                return item.name_en
            }
        }
    };

    componentDidMount() {

    }

    getScore = async (memberCode, id) => {
        await httpRequest.getScore(memberCode, id).then(result => {
            this.setState({
                scoreHis: result.data.result.data[0],
                hole_01: result.data.result.data[0].hole_01,
                hole_02: result.data.result.data[0].hole_02,
                hole_03: result.data.result.data[0].hole_03,
                hole_04: result.data.result.data[0].hole_04,
                hole_05: result.data.result.data[0].hole_05,
                hole_06: result.data.result.data[0].hole_06,
                hole_07: result.data.result.data[0].hole_07,
                hole_08: result.data.result.data[0].hole_08,
                hole_09: result.data.result.data[0].hole_09,
                hole_10: result.data.result.data[0].hole_10,
                hole_11: result.data.result.data[0].hole_11,
                hole_12: result.data.result.data[0].hole_12,
                hole_13: result.data.result.data[0].hole_13,
                hole_14: result.data.result.data[0].hole_14,
                hole_15: result.data.result.data[0].hole_15,
                hole_16: result.data.result.data[0].hole_16,
                hole_17: result.data.result.data[0].hole_17,
                hole_18: result.data.result.data[0].hole_18,
                course_code: this.setName(result.data.result.data[0].course_id),
                course_rating: result.data.result.data[0].course_rating,
                slope_rating: result.data.result.data[0].slope_rating,
                handicap_diff: result.data.result.data[0].handicap_diff,
                score_total: result.data.result.data[0].gross,
                teeoff: result.data.result.data[0].teeoff,
                playDate: moment(result.data.result.data[0].play_date).format('DD/MM/YYYY')
            })
        }).catch(error => {
            console.log(error);
        })
    }

    changeLanguage = (lng) => {
        i18n.changeLanguage(lng);
    }

    render() {
        const {t} = this.props;
        const {playDate, scoreHis, teeoff, score_total, handicap_diff, course_rating, slope_rating, course_code, hole_01, hole_02, hole_03, hole_04, hole_05, hole_06, hole_07, hole_08, hole_09, hole_10, hole_11, hole_12, hole_13, hole_14, hole_15, hole_16, hole_17, hole_18} = this.state

        const rows = [
            createData('1', teeoff['hole_par_01'], hole_01),
            createData('2', teeoff['hole_par_02'], hole_02),
            createData('3', teeoff['hole_par_03'], hole_03),
            createData('4', teeoff['hole_par_04'], hole_04),
            createData('5', teeoff['hole_par_05'], hole_05),
            createData('6', teeoff['hole_par_06'], hole_06),
            createData('7', teeoff['hole_par_07'], hole_07),
            createData('8', teeoff['hole_par_08'], hole_08),
            createData('9', teeoff['hole_par_09'], hole_09),
        ];
        const sumScoreOut = hole_01 + hole_02 + hole_03 + hole_04 + hole_05 + hole_06 + hole_07 + hole_08 + hole_09
        const sumParOut = rows[0].par + rows[1].par + rows[2].par + rows[3].par + rows[4].par + rows[5].par + rows[6].par + rows[7].par + rows[8].par
        const rows2 = [
            createData('10', teeoff['hole_par_10'], hole_10),
            createData('11', teeoff['hole_par_11'], hole_11),
            createData('12', teeoff['hole_par_12'], hole_12),
            createData('13', teeoff['hole_par_13'], hole_13),
            createData('14', teeoff['hole_par_14'], hole_14),
            createData('15', teeoff['hole_par_15'], hole_15),
            createData('16', teeoff['hole_par_16'], hole_16),
            createData('17', teeoff['hole_par_17'], hole_17),
            createData('18', teeoff['hole_par_18'], hole_18),
        ];
        const sumScoreIn = hole_10 + hole_11 + hole_12 + hole_13 + hole_14 + hole_15 + hole_16 + hole_17 + hole_18
        const sumParIn = rows2[0].par + rows2[1].par + rows2[2].par + rows2[3].par + rows2[4].par + rows2[5].par + rows2[6].par + rows2[7].par + rows2[8].par
        const handleClickBack = () => {
            this.props.handleClick()
        };
        const diffOut = sumScoreOut - sumParOut
        const diffIn = sumScoreIn - sumParIn

        const sumPar = sumParOut + sumParIn
        const sumScore = sumScoreOut + sumScoreIn
        const sumScoreDiff = sumScore - sumPar

        return (
            <div id="app">
                {this.props.match && this.props.match.path === "/scoreHistory/:memberID/:id/:lang" ? <div></div> :
                    <h6 className="text-left back-title-white cursor" onClick={() => handleClickBack()}><span
                        className="icon-back"><i className="ti-angle-left mr-2 icon-center"/>{t('back')}</span></h6>}
                <div className="bg-history">
                    <p className={`color-white container pt-4 ${isMobile ? 'pl-3' : 'pl-5'}`}
                       style={{fontSize: "18px"}}>{playDate}</p>
                </div>
                <section className="services-area pt-3">
                    <div className="container set-bgHistory">

                        <Grid container spacing={1}>
                            <div className="col card box-s">
                                <div className="row display-card-content">
                                    <Grid container spacing={1}>
                                        <Grid item xs={12} sm={12}>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6} sm={6} className="pt-3">
                                                    <p className={`secondary-color ${isMobile ? 'pl-3' : 'pl-5'}`}>{t('course')}</p>
                                                    <p className={`blue-color ${isMobile ? 'pl-3' : 'pl-5'}`}>{course_code ? course_code : "N/A"}</p>
                                                </Grid>
                                                <Grid item xs={6} sm={6} className="text-right pt-3">
                                                    <p className={`secondary-color ${isMobile ? 'pr-3' : 'pr-5'}`}>{t('courseRating')} </p>
                                                    <p className={`blue-color ${isMobile ? 'pr-3' : 'pr-5'}`}>{course_rating ? course_rating : "N/A"}</p>
                                                </Grid>
                                            </Grid>
                                            <Grid container spacing={2}>
                                                <Grid item xs={6} sm={6} className="center-align">
                                                    <p className={`secondary-color ${isMobile ? 'pl-3' : 'pl-5'}`}>{t('teeBox')}</p>
                                                    <p className={`blue-color ${isMobile ? 'pl-3' : 'pl-5'}`}>{teeoff ? teeoff.display_name : "N/A"}</p>
                                                </Grid>
                                                <Grid item xs={6} sm={6} className="text-right">
                                                    <p className={`secondary-color ${isMobile ? 'pr-3' : 'pr-5'}`}>{t('slopeRating')}</p>
                                                    <p className={`blue-color ${isMobile ? 'pr-3' : 'pr-5'}`}>{slope_rating ? slope_rating : "N/A"}</p>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </div>
                                <div className={`row ${isMobile ? "border-hr-mobile" : "border-hr"}`}/>
                                <div className="row display-card-content">
                                    <Grid container spacing={2}>
                                        <Grid item xs={6} sm={6} className="pt-3">
                                            <p className={`secondary-color ${isMobile ? 'pl-3' : 'pl-5'}`}>{t('handicapDifferential')}</p>
                                            <p className={`blue-color ${isMobile ? 'pl-3' : 'pl-5'}`}>{handicap_diff ? handicap_diff : "N/A"}</p>
                                        </Grid>
                                        <Grid item xs={6} sm={6} className="text-right pt-3">
                                            <p className={`secondary-color ${isMobile ? 'pr-3' : 'pr-5'}`}>{t('gross')}</p>
                                            <p className={`blue-color ${isMobile ? 'pr-3' : 'pr-5'}`}>{score_total ? score_total : "N/A"}</p>
                                        </Grid>
                                    </Grid>
                                </div>
                            </div>
                        </Grid>
                        {scoreHis ?
                            <>
                                {this.props.match && this.props.match.path === "/scoreHistory/:memberID/:id/:lang" ?
                                    // <MobileView>
                                    <Grid container spacing={2} className="place-center">
                                        <Grid item>
                                            <div className="card width-120 box-s mb-1 pt-2">
                                                <p style={{color: '#ED1C24', lineHeight: "20px"}}>{t('less')} </p>
                                                <p className="blue-color">{scoreHis.hole_in_one}</p>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            <div className="card width-120 box-s mb-1 pt-2">
                                                <p style={{color: '#ED1C24', lineHeight: "20px"}}>{t('albatross')} </p>
                                                <p className="blue-color">{scoreHis.albatross}</p>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            <div className="card width-120 box-s mb-1 pt-2">
                                                <p style={{color: '#ED1C24', lineHeight: "16px"}}>{t('eagle')} </p>
                                                <p className="blue-color ">{scoreHis.eagle}</p>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            <div className="card width-120 box-s mb-1 pt-2">
                                                <p style={{color: '#ED1C24', lineHeight: "16px"}}>{t('birdie')}</p>
                                                <p className="blue-color">{scoreHis.birdie}</p>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            <div className="card width-120 box-s mb-1 pt-2">
                                                <p style={{color: '#454243', lineHeight: "16px"}}>{t('par')} </p>
                                                <p className="blue-color">{scoreHis.par}</p>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            <div className="card width-120 box-s mb-1 pt-2">
                                                <p style={{color: '#DE8500', lineHeight: "16px"}}>{t('bogey')} </p>
                                                <p className="blue-color">{scoreHis.bogey}</p>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            <div className="card width-120 box-s mb-1 pt-2">
                                                <p style={{color: '#DE8500', lineHeight: "16px"}}>{t('dBogey')} </p>
                                                <p className="blue-color">{scoreHis.double_bogey}</p>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            <div className="card width-120 box-s mb-1 pt-2">
                                                <p style={{color: '#DE8500', lineHeight: "16px"}}>{t('more')} </p>
                                                <p className="blue-color">{scoreHis.more}</p>
                                            </div>
                                        </Grid>
                                    </Grid>
                                    // </MobileView>
                                    :
                                    //    <BrowserView>
                                    <Grid container spacing={2} className="place-center">
                                        <Grid item>
                                            <div className="card width-120 box-s mb-1 pt-2">
                                                <p style={{color: '#ED1C24', lineHeight: "16px"}}>{t('less')} </p>
                                                <p className="blue-color">{scoreHis.hole_in_one}</p>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            <div className="card width-120 box-s mb-1 pt-2">
                                                <p style={{color: '#ED1C24', lineHeight: "16px"}}>{t('albatross')} </p>
                                                <p className="blue-color">{scoreHis.albatross}</p>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            <div className="card width-120 box-s mb-1 pt-2">
                                                <p style={{color: '#ED1C24', lineHeight: "16px"}}>{t('eagle')} </p>
                                                <p className="blue-color ">{scoreHis.eagle}</p>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            <div className="card width-120 box-s mb-1 pt-2">
                                                <p style={{color: '#ED1C24', lineHeight: "16px"}}>{t('birdie')}</p>
                                                <p className="blue-color">{scoreHis.birdie}</p>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            <div className="card width-120 box-s mb-1 pt-2">
                                                <p style={{color: '#454243', lineHeight: "16px"}}>{t('par')} </p>
                                                <p className="blue-color">{scoreHis.par}</p>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            <div className="card width-120 box-s mb-1 pt-2">
                                                <p style={{color: '#DE8500', lineHeight: "16px"}}>{t('bogey')} </p>
                                                <p className="blue-color">{scoreHis.bogey}</p>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            <div className="card width-120 box-s mb-1 pt-2">
                                                <p style={{color: '#00773E', lineHeight: "16px"}}>{t('dBogey')} </p>
                                                <p className="blue-color">{scoreHis.double_bogey}</p>
                                            </div>
                                        </Grid>
                                        <Grid item>
                                            <div className="card width-120 box-s mb-1 pt-2">
                                                <p style={{color: '#00773E', lineHeight: "16px"}}>{t('more')} </p>
                                                <p className="blue-color">{scoreHis.more}</p>
                                            </div>
                                        </Grid>
                                    </Grid>
                                    //    </BrowserView>
                                }
                            </> : <></>
                        }
                        <section className="pt-30">
                            <Grid container spacing={2}>
                                <Grid item xs={12} sm={6}>
                                    <TableContainer component={Paper} className="box-s" style={{"overflowX": "hidden", borderRadius: "10px"}}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow style={{"background": "#FFFFFF"}}>
                                                    <TableCell align="center" className="br-bottom-1" style={{padding: "9px"}}>
                                                        <span className="blue-color">{t('hole')}</span>
                                                    </TableCell>
                                                    <TableCell align="center" className="br-bottom-1" style={{padding: "9px"}}>
                                                        <span className="blue-color">{t('par')}</span>
                                                    </TableCell>
                                                    <TableCell align="center" className="br-bottom-1" style={{padding: "9px"}}>
                                                        <span className="blue-color">{t('score')}</span>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rows.map((row) => {
                                                    const diff = row.score - row.par

                                                    return (
                                                        <TableRow key={row.hole}>
                                                            <TableCell align="center" component="th" scope="row">
                                                                {row.hole}
                                                            </TableCell>
                                                            <TableCell align="center">{row.par}</TableCell>
                                                            <TableCell valign="middle" align="center" style={{color: diff === 0 ? '#908F90' : diff > 0 ? diff >= 2 ? '#00773E' : '#DE8500' : '#ED1C24'}}><span>{row.score}</span> <span style={{fontSize: '11px'}}>{diff === 0 ? '-' : diff > 0 ? `+${diff}` : diff}</span></TableCell>
                                                        </TableRow>
                                                    )
                                                })}
                                                <TableRow className="br-top-1">
                                                    <TableCell align="center" className="blue-color">{t('out')}</TableCell>
                                                    <TableCell align="center" className="blue-color">{sumParOut}</TableCell>
                                                    <TableCell align="center" valign="middle" className="blue-color"><span>{sumScoreOut}</span> <span style={{fontSize: '11px'}}>{diffOut > 0 ? `+${diffOut}` : diffOut}</span></TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TableContainer component={Paper} className="box-s" style={{"overflowX": "hidden", borderRadius: "10px"}}>
                                        <Table aria-label="simple table">
                                            <TableHead>
                                                <TableRow style={{"background": "#FFFFFF"}}>
                                                    <TableCell align="center" className="br-bottom-1" style={{padding: "9px"}}>
                                                        <span className="blue-color">{t('hole')}</span>
                                                    </TableCell>
                                                    <TableCell align="center" className="br-bottom-1" style={{padding: "9px"}}>
                                                        <span className="blue-color">{t('par')}</span>
                                                    </TableCell>
                                                    <TableCell align="center" className="br-bottom-1" style={{padding: "9px"}}>
                                                        <span className="blue-color">{t('score')}</span>
                                                    </TableCell>
                                                </TableRow>
                                            </TableHead>
                                            <TableBody>
                                                {rows2.map((row) => {
                                                    const diff = row.score - row.par

                                                    return (
                                                        <TableRow key={row.hole}>
                                                            <TableCell align="center" component="th" scope="row">
                                                                {row.hole}
                                                            </TableCell>
                                                            <TableCell align="center">{row.par}</TableCell>
                                                            <TableCell valign="middle" align="center" style={{color: diff === 0 ? '#908F90' : diff > 0 ? diff >= 2 ? '#00773E' : '#DE8500' : '#ED1C24'}}><span>{row.score}</span> <span style={{fontSize: '11px'}}>{diff === 0 ? '-' : diff > 0 ? `+${diff}` : diff}</span></TableCell>
                                                        </TableRow>
                                                    )
                                                })}
                                                <TableRow className="br-top-1">
                                                    <TableCell align="center" className="blue-color">{t('in')}</TableCell>
                                                    <TableCell align="center" className="blue-color">{sumParIn}</TableCell>
                                                    <TableCell align="center" valign="middle" className="blue-color"><span>{sumScoreIn}</span> <span style={{fontSize: '11px'}}>{diffIn > 0 ? `+${diffIn}` : diffIn}</span></TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                            <h6 className="p-4 text-left mb-0">{t('total')}</h6>
                            <Grid container spacing={2}>
                                <Grid item xs={6} sm={6}>
                                    <TableContainer component={Paper} style={{"overflowX": "hidden", borderRadius: "10px"}}>
                                        <Table aria-label="simple table">
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell align="left" className="blue-color pl-3 p-0">{t('par')}</TableCell>
                                                    <TableCell align="center" className="blue-color p-0"/>
                                                    <TableCell align="center" className="blue-color p-0">{sumPar}</TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                                <Grid item xs={6} sm={6}>
                                    <TableContainer component={Paper} style={{"overflowX": "hidden", borderRadius: "10px"}}>
                                        <Table aria-label="simple table">
                                            <TableBody>
                                                <TableRow>
                                                    <TableCell align="left" className="blue-color pl-3 p-0">{t('score')}</TableCell>
                                                    <TableCell align="center" className="blue-color p-0"/>
                                                    <TableCell align="center" className="blue-color p-0"><span>{sumScore}</span> <span>{sumScoreDiff > 0 ? `+${sumScoreDiff}` : sumScoreDiff}</span></TableCell>
                                                </TableRow>
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Grid>
                            </Grid>
                        </section>
                    </div>
                </section>
            </div>
        );
    }
}

export default withNamespaces()(ScoreHistoryDetail)
